import { orderBy, toLower, toUpper } from "lodash";
import { isBooleanTrue, isListNotEmpty, isObjectNotEmpty, isStringNotEmpty } from "./objectUtils";
import { getEffectiveOfferGroupId, getOfferGroupById } from "./productIdentityUtils";

export const DEFAULT_FUNNEL_CHOICE_SETS = [
    {
        id: 'WL_GLP1',
        name: 'Weight Loss GLP-1',
        enabled: true,
        programSlug: 'wl',
        defaultForProgram: true,
        defaultOfferGroupId: 'SE',
        entryOfferGroupIds: ['SE', 'TI', 'OZ', 'ZE'],
        renderMode: 'PRODUCT_CARDS_WITH_SECTIONS',
        sections: [
            {
                key: 'COMPOUNDED',
                label: 'Compounded',
                displayOrder: 1,
                defaultVisible: true,
                options: [
                    { offerGroupId: 'SE', displayOrder: 1, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'TI', displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
            {
                key: 'BRANDED',
                label: 'Branded',
                displayOrder: 2,
                defaultVisible: false,
                options: [
                    { offerGroupId: 'OZ', displayOrder: 1, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'ZE', displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
        ],
    },
    {
        id: 'GMD_GLP1',
        name: 'GLP-1 Microdosing',
        enabled: true,
        programSlug: 'gmd',
        defaultForProgram: true,
        defaultOfferGroupId: 'SEMD',
        entryOfferGroupIds: ['SEMD', 'TIMD'],
        renderMode: 'PRODUCT_CARDS',
        sections: [
            {
                key: 'DEFAULT',
                label: 'GLP-1 Microdosing',
                displayOrder: 1,
                defaultVisible: true,
                options: [
                    { offerGroupId: 'SEMD', displayOrder: 1, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'TIMD', displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
        ],
    },
    {
        id: 'L_GLUTATHIONE',
        name: 'Longevity Glutathione',
        enabled: true,
        programSlug: 'l',
        defaultOfferGroupId: 'GL',
        entryOfferGroupIds: ['GL', 'GLN'],
        renderMode: 'PRODUCT_CARDS',
        sections: [
            {
                key: 'DEFAULT',
                label: 'Glutathione',
                displayOrder: 1,
                defaultVisible: true,
                options: [
                    { offerGroupId: 'GL', displayOrder: 1, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'GLN', displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
        ],
    },
    {
        id: 'L_NAD',
        name: 'Longevity NAD+',
        enabled: true,
        programSlug: 'l',
        defaultOfferGroupId: 'NA',
        entryOfferGroupIds: ['NA', 'NAN'],
        renderMode: 'PRODUCT_CARDS',
        sections: [
            {
                key: 'DEFAULT',
                label: 'NAD+',
                displayOrder: 1,
                defaultVisible: true,
                options: [
                    { offerGroupId: 'NA', displayOrder: 1, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'NAN', displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
        ],
    },
    {
        id: 'L_METFORMIN',
        name: 'Longevity Metformin',
        enabled: true,
        programSlug: 'l',
        defaultOfferGroupId: 'ME',
        entryOfferGroupIds: ['ME'],
        renderMode: 'PRODUCT_CARDS',
        sections: [
            {
                key: 'DEFAULT',
                label: 'Metformin',
                displayOrder: 1,
                defaultVisible: true,
                options: [
                    { offerGroupId: 'ME', displayOrder: 1, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
        ],
    },
    {
        id: 'MS_SERMORELIN',
        name: 'Metabolic Support Sermorelin',
        enabled: true,
        programSlug: 'ms',
        defaultOfferGroupId: 'SER',
        entryOfferGroupIds: ['SER', 'SERO'],
        renderMode: 'PRODUCT_CARDS',
        sections: [
            {
                key: 'DEFAULT',
                label: 'Sermorelin',
                displayOrder: 1,
                defaultVisible: true,
                options: [
                    { offerGroupId: 'SER', displayOrder: 1, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'SERO', displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
        ],
    },
    {
        id: 'MS_B12',
        name: 'Metabolic Support B12',
        enabled: true,
        programSlug: 'ms',
        defaultOfferGroupId: 'LB',
        entryOfferGroupIds: ['LB'],
        renderMode: 'PRODUCT_CARDS',
        sections: [
            {
                key: 'DEFAULT',
                label: 'Lipotropic B12',
                displayOrder: 1,
                defaultVisible: true,
                options: [
                    { offerGroupId: 'LB', productSkus: ['MIC-B12'], displayOrder: 1, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'LB', productSkus: ['B12'], displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', noticeMessage: "*Based on your state, we're only able to offer Cyanocobalamin (Vitamin B12) at this time instead of MIC-B12.", defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
        ],
    },
    {
        id: 'SC_FACE_CREAM',
        name: 'Skin Care Face Cream',
        enabled: true,
        programSlug: 'sc',
        defaultForProgram: true,
        defaultOfferGroupId: 'FCE',
        entryOfferGroupIds: ['FCE', 'FCT'],
        renderMode: 'PRODUCT_CARDS_WITH_SECTIONS',
        sections: [
            {
                key: 'DAY_90',
                label: '90 Day',
                displayOrder: 1,
                defaultVisible: true,
                options: [
                    { offerGroupId: 'FCE', productSkus: ['FACE-CREAM-E-90'], entryTokens: ['fce90', 'face-cream-e-90'], displayOrder: 1, allowedGenders: ['FEMALE'], productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'FCT', productSkus: ['FACE-CREAM-T-90'], entryTokens: ['fct90', 'face-cream-r-90', 'face-cream-t-90'], displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
            {
                key: 'DAY_30',
                label: '30 Day',
                displayOrder: 2,
                defaultVisible: false,
                options: [
                    { offerGroupId: 'FCE', productSkus: ['FACE-CREAM-E'], entryTokens: ['fce', 'face-cream-e'], displayOrder: 1, allowedGenders: ['FEMALE'], productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                    { offerGroupId: 'FCT', productSkus: ['FACE-CREAM-T'], entryTokens: ['fct', 'face-cream-r', 'face-cream-t'], displayOrder: 2, productResolutionMode: 'CANONICAL_BY_DISPLAY_ORDER', defaultVariantStrategy: 'DISPLAY_ORDER' },
                ],
            },
        ],
    },
];

const normalizeGender = (gender) => {
    return isStringNotEmpty(gender) ? toUpper(gender) : null;
};

const normalizeState = (shippingState) => {
    return isStringNotEmpty(shippingState) ? toUpper(shippingState) : null;
};

const getProgramSlug = (program) => {
    return isStringNotEmpty(program?.slug) ? toLower(program.slug) : null;
};

export const getEffectiveFunnelChoiceSets = (choiceSets = []) => {
    return isListNotEmpty(choiceSets) ? choiceSets : DEFAULT_FUNNEL_CHOICE_SETS;
};

export const getFunnelChoiceSetById = (choiceSetId, choiceSets = []) => {
    if (!isStringNotEmpty(choiceSetId)) {
        return null;
    }

    return getEffectiveFunnelChoiceSets(choiceSets).find((choiceSet) => choiceSet.id === choiceSetId) ?? null;
};

const isChoiceSetForProgram = (choiceSet, programId = null, program = null) => {
    if (isStringNotEmpty(programId) && choiceSet.programId === programId) {
        return true;
    }

    if (isObjectNotEmpty(program) && choiceSet.programId === program.id) {
        return true;
    }

    return isStringNotEmpty(choiceSet.programSlug) && choiceSet.programSlug === getProgramSlug(program);
};

export const getFunnelChoiceSetForEntry = ({ programId = null, program = null, offerGroupId = null, choiceSets = [] }) => {
    const enabledChoiceSets = getEffectiveFunnelChoiceSets(choiceSets).filter((choiceSet) => isBooleanTrue(choiceSet.enabled));
    const programChoiceSets = enabledChoiceSets.filter((choiceSet) => isChoiceSetForProgram(choiceSet, programId, program));

    if (isStringNotEmpty(offerGroupId)) {
        const entryMatch = programChoiceSets.find((choiceSet) => {
            return Array.isArray(choiceSet.entryOfferGroupIds) && choiceSet.entryOfferGroupIds.includes(offerGroupId);
        });
        if (isObjectNotEmpty(entryMatch)) {
            return entryMatch;
        }
    }

    return programChoiceSets.find((choiceSet) => isBooleanTrue(choiceSet.defaultForProgram))
        ?? programChoiceSets[0]
        ?? null;
};

export const isProductEligibleForFunnel = (product, { shippingState = null, testMode = false } = {}) => {
    if (!isObjectNotEmpty(product)) {
        return false;
    }

    if (!isBooleanTrue(product.purchasable)) {
        return false;
    }

    if (!isBooleanTrue(product.visibleToCustomers) && !isBooleanTrue(testMode)) {
        return false;
    }

    if (!isListNotEmpty(product.productRules)) {
        return false;
    }

    const normalizedShippingState = normalizeState(shippingState);
    if (isStringNotEmpty(normalizedShippingState)) {
        return product.productRules.some((rule) => {
            return normalizeState(rule.state) === normalizedShippingState
                && isBooleanTrue(rule.canBill)
                && isBooleanTrue(rule.canShip);
        });
    }

    return product.productRules.some((rule) => isBooleanTrue(rule.canBill) && isBooleanTrue(rule.canShip));
};

export const getEligibleProductsForProgram = (program, products = [], { shippingState = null, testMode = false } = {}) => {
    if (!isObjectNotEmpty(program) || !isListNotEmpty(program.productIds) || !isListNotEmpty(products)) {
        return [];
    }

    return products.filter((product) => {
        return program.productIds.includes(product.id)
            && isProductEligibleForFunnel(product, { shippingState, testMode });
    });
};

const getOptionOfferGroupIds = (option = {}) => {
    return Array.from(new Set([
        option.offerGroupId,
        ...(Array.isArray(option.alternateOfferGroupIds) ? option.alternateOfferGroupIds : []),
    ].filter((offerGroupId) => isStringNotEmpty(offerGroupId))));
};

const normalizeOptionToken = (value) => {
    return isStringNotEmpty(value) ? toLower(value.trim()) : null;
};

const doesOptionMatchEntryToken = (option = {}, requestedProductValue = null) => {
    const normalizedRequestedProductValue = normalizeOptionToken(requestedProductValue);
    if (!isStringNotEmpty(normalizedRequestedProductValue)) {
        return false;
    }

    return [
        ...(Array.isArray(option.entryTokens) ? option.entryTokens : []),
        ...(Array.isArray(option.productSkus) ? option.productSkus : []),
    ]
        .some((entryToken) => normalizeOptionToken(entryToken) === normalizedRequestedProductValue);
};

const doesProductMatchOptionProductConstraints = (product, { productIds = [], productSkus = [] } = {}) => {
    const normalizedProductIds = Array.isArray(productIds) ? productIds.filter((productId) => isStringNotEmpty(productId)) : [];
    const normalizedProductSkus = Array.isArray(productSkus) ? productSkus.map(normalizeOptionToken).filter((productSku) => isStringNotEmpty(productSku)) : [];

    if (isListNotEmpty(normalizedProductIds) && !normalizedProductIds.includes(product?.id)) {
        return false;
    }

    if (isListNotEmpty(normalizedProductSkus)) {
        const productSku = normalizeOptionToken(product?.sku);
        const productShortSku = normalizeOptionToken(product?.shortSku);
        return normalizedProductSkus.includes(productSku) || normalizedProductSkus.includes(productShortSku);
    }

    return true;
};

const getProductsForOfferGroupIds = (offerGroupIds = [], products = [], option = {}) => {
    return products.filter((product) => {
        return offerGroupIds.includes(getEffectiveOfferGroupId(product))
            && doesProductMatchOptionProductConstraints(product, option);
    });
};

export const getCanonicalProductForOfferGroup = ({ offerGroupId = null, offerGroupIds = null, program = null, products = [], shippingState = null, testMode = false, productIds = [], productSkus = [] }) => {
    const candidateOfferGroupIds = Array.isArray(offerGroupIds) && isListNotEmpty(offerGroupIds)
        ? offerGroupIds
        : [offerGroupId].filter((value) => isStringNotEmpty(value));

    if (!isListNotEmpty(candidateOfferGroupIds)) {
        return null;
    }

    const eligibleProducts = isObjectNotEmpty(program)
        ? getEligibleProductsForProgram(program, products, { shippingState, testMode })
        : products.filter((product) => isProductEligibleForFunnel(product, { shippingState, testMode }));

    const matchingProducts = getProductsForOfferGroupIds(candidateOfferGroupIds, eligibleProducts, { productIds, productSkus });
    return orderBy(matchingProducts, ['displayOrder', 'name'], ['asc', 'asc'])[0] ?? null;
};

export const getCanonicalProductForChoiceSetOfferGroup = ({ choiceSet = null, offerGroupId = null, requestedProductValue = null, program = null, products = [], shippingState = null, testMode = false }) => {
    const options = (choiceSet?.sections ?? []).flatMap((section) => section.options ?? []);
    const entryTokenOptions = orderBy(options.filter((option) => doesOptionMatchEntryToken(option, requestedProductValue)), ['displayOrder', 'offerGroupId'], ['asc', 'asc']);
    const offerGroupOptions = orderBy(options.filter((option) => {
        const optionOfferGroupIds = getOptionOfferGroupIds(option);
        return option.offerGroupId === offerGroupId || optionOfferGroupIds.includes(offerGroupId);
    }), ['displayOrder', 'offerGroupId'], ['asc', 'asc']);
    const matchingOptions = isListNotEmpty(entryTokenOptions) ? entryTokenOptions : offerGroupOptions;

    for (const matchingOption of matchingOptions) {
        const offerGroupIds = getOptionOfferGroupIds(matchingOption);
        const product = getCanonicalProductForOfferGroup({
            offerGroupIds,
            program,
            products,
            shippingState,
            testMode,
            productIds: matchingOption?.productIds ?? [],
            productSkus: matchingOption?.productSkus ?? [],
        });

        if (isObjectNotEmpty(product)) {
            return product;
        }
    }

    return getCanonicalProductForOfferGroup({
        offerGroupId,
        program,
        products,
        shippingState,
        testMode,
    });
};

const isGenderAllowed = (option, gender) => {
    if (!isListNotEmpty(option.allowedGenders)) {
        return true;
    }

    // fails CLOSED: an option naming allowedGenders is gender-restricted, so a visitor who has not
    // answered the gender step must not satisfy it
    const normalizedGender = normalizeGender(gender);
    return isStringNotEmpty(normalizedGender) && option.allowedGenders.map(normalizeGender).includes(normalizedGender);
};

const getDefaultVariantForProduct = (product, variants = []) => {
    if (!isObjectNotEmpty(product) || !isListNotEmpty(variants)) {
        return null;
    }

    const eligibleVariants = variants.filter((variant) => variant.productId === product.id && isBooleanTrue(variant.enabled));
    return orderBy(eligibleVariants, ['displayOrder', 'name'], ['asc', 'asc'])[0] ?? null;
};

export const buildFunnelChoiceOptions = ({ choiceSet = null, offerGroups = [], products = [], variants = [], shippingState = null, gender = null, testMode = false, program = null } = {}) => {
    if (!isObjectNotEmpty(choiceSet)) {
        return [];
    }

    const orderedSections = orderBy(choiceSet.sections ?? [], ['displayOrder', 'label'], ['asc', 'asc']);
    return orderedSections.map((section) => {
        const orderedOptions = orderBy(section.options ?? [], ['displayOrder', 'offerGroupId'], ['asc', 'asc']).map((option) => {
            const offerGroupIds = getOptionOfferGroupIds(option);
            const canonicalProduct = getCanonicalProductForOfferGroup({
                offerGroupIds,
                program,
                products,
                shippingState,
                testMode,
                productIds: option.productIds ?? [],
                productSkus: option.productSkus ?? [],
            });
            const genderEligible = isGenderAllowed(option, gender);
            const offerGroup = getOfferGroupById(option.offerGroupId, offerGroups);

            return {
                ...option,
                offerGroupIds,
                offerGroup,
                canonicalProduct: genderEligible ? canonicalProduct : null,
                defaultVariant: genderEligible ? getDefaultVariantForProduct(canonicalProduct, variants) : null,
                isAvailable: genderEligible && isObjectNotEmpty(canonicalProduct),
                isGenderEligible: genderEligible,
            };
        });

        return {
            ...section,
            options: orderedOptions,
        };
    });
};

export const getChoiceSetProducts = ({ choiceSetId = null, sectionKey = null, choiceSet = null, choiceSets = [], offerGroups = [], products = [], variants = [], program = null, shippingState = null, gender = null, testMode = false } = {}) => {
    const resolvedChoiceSet = isObjectNotEmpty(choiceSet) ? choiceSet : getFunnelChoiceSetById(choiceSetId, choiceSets);
    const sections = buildFunnelChoiceOptions({
        choiceSet: resolvedChoiceSet,
        offerGroups,
        products,
        variants,
        program,
        shippingState,
        gender,
        testMode,
    });

    const filteredSections = isStringNotEmpty(sectionKey)
        ? sections.filter((section) => section.key === sectionKey)
        : sections;

    const productMap = new Map();
    filteredSections.forEach((section) => {
        section.options.forEach((option) => {
            if (isObjectNotEmpty(option.canonicalProduct) && !productMap.has(option.canonicalProduct.id)) {
                productMap.set(option.canonicalProduct.id, {
                    ...option.canonicalProduct,
                    funnelChoiceSetId: resolvedChoiceSet?.id ?? null,
                    funnelChoiceSectionKey: section.key,
                    funnelChoiceOfferGroupId: option.offerGroupId,
                    funnelChoiceBadgeLabel: option.badgeLabel ?? null,
                    funnelChoiceNoticeMessage: option.noticeMessage ?? null,
                    funnelChoiceUnavailableMessage: option.unavailableMessage ?? null,
                });
            }
        });
    });

    return Array.from(productMap.values());
};
